module.exports = [
  {
    id: 1003,
    //nextId: 1008,
    isQuestion: true,
    componentName: 'MultiplierQuestion',
    playTitle: '',
    choices: [],
    correctAnswer: '',
    forTeam: {},
    title: '',
    shortHand: 'Live Play',
    choiceType: 'MULTI',
    points: 0,
    tokens: 0,
    answer: 1,
    labels: [],
    length: 0,
    inProgressLength: 3,
    specialTimer: 13,
    isMultiplier: true,
    backgroundColor: '#c61818',
    backgroundImage: 'playalong-kickoff.jpg',
    ringColor: '#000000',
    //hideTimeout: true,
    type: 'LivePlay',
    multiplier: 1,
    isHistory: false,
    started: null,
    result: {
      result: '',
      period: '',
      teamIndex: 1,
    },
  },
  {
    id: 1008,
    //nextId: 1012,
    isQuestion: true,
    componentName: 'GameMasterQuestion',
    playTitle: '',
    choices: [],
    correctAnswer: '',
    forTeam: {},
    title: 'GameMaster',
    shortHand: 'GameMaster',
    choiceType: 'MULTI',
    points: 0,
    tokens: 0,
    answer: 1,
    labels: [],
    length: 0,
    specialTimer: 27,
    isMultiplier: false,
    backgroundColor: '#19d1bf',
    backgroundImage: 'playalong-kickoff.jpg',
    ringColor: '#000000',
    ringImage: 'symbol-gm_white.svg',
    //showResult: true,
    //hideTimeout: true,
    stars: 0,
    type: 'GameMaster',
    isHistory: false,
    started: null,
    result: {
      result: '',
      period: '',
      teamIndex: 1,
    },
  },
  {
    id: 2002,
    //nextId: 2003,
    isQuestion: true,
    componentName: 'SponsorQuestion',
    playTitle: '',
    choices: [],
    correctAnswer: '',
    forTeam: {},
    title: 'Sponsor Play',
    shortHand: 'Sponsor Play',
    choiceType: 'MULTI',
    points: 3900,
    tokens: 50,
    answer: 1,
    labels: [],
    length: 0,
    specialTimer: 27,
    isMultiplier: false,
    backgroundColor: '#495bdb',
    backgroundImage: 'playalong-kickoff.jpg',
    ringColor: '#000000',
    ringImage: 'symbol-sponsor_white.svg',
    showResult: false,
    stars: 0,
    type: 'Sponsor',
    isHistory: false,
    started: null,
    result: {
      result: '',
      period: '',
      teamIndex: 0,
    },
  },
  {
    id: 1016,
    // nextId: 1017,
    isQuestion: true,
    componentName: 'AdvertisementQuestion',
    playTitle: '',
    choices: [],
    correctAnswer: '',
    forTeam: {},
    title: 'Prize Play',
    shortHand: 'Prize Play',
    choiceType: 'MULTI',
    points: 0,
    tokens: 0,
    answer: 1,
    labels: [],
    length: 0,
    specialTimer: 27,
    isMultiplier: false,
    backgroundColor: '#9368AA',
    backgroundImage: 'playalong-kickoff.jpg',
    ringColor: '#000000',
    ringImage: 'symbol-prize_white.svg',
    prizeImage: 'prize-icon-coffee.jpg',
    prizeDesc: 'Free Coffee',
    prizeDetailDesc: 'Prize Play',
    prizePoints: 0,
    //showResult: true,
    //hideTimeout: true,
    stars: 0,
    type: 'Prize',
    isHistory: false,
    started: null,
    result: {
      result: '',
      period: '',
      teamIndex: 1,
    },
  },
  {
    id: 9999,
    nextId: 0,
    componentName: 'Summary',
    title: 'Summary',
    shortHand: 'Summary',
  },
  {
    id: 10000,
    nextId: 0,
    componentName: 'NextPlayAd',
    title: 'NextPlayAd',
    shortHand: 'Next Play',
    backgroundImage: 'playalong-begin.jpg',
    type: 'NextPlayAd',
  },
  {
    id: 10001,
    nextId: 0,
    componentName: 'Announce',
    title: 'Announce',
    shortHand: 'Announcement',
    backgroundImage: 'playalong-begin.jpg',
    sponsor: null,
    started: null,
    type: 'Announce',
  },
  {
    id: 10002,
    nextId: 0,
    componentName: 'Standby',
    title: 'Standby',
    shortHand: 'Stand By',
    backgroundImage: 'playalong-begin.jpg',
    type: 'Standy',
  },
  {
    id: 10003,
    nextId: 0,
    componentName: 'ResetDatabase',
    title: 'ResetDatabase',
    shortHand: 'ResetDatabase',
    backgroundImage: 'playalong-begin.jpg',
    type: 'ResetDatabase',
  },
  {
    id: 10004,
    nextId: 0,
    componentName: 'PostGame',
    title: 'PostGame',
    shortHand: 'PostGame',
    backgroundImage: '',
    type: 'PostGame'
  }
]



// WEBPACK FOOTER //
// src/Components/Preview/PlayScript.js